<template>
<div v-if="student_nom">
<div v-if="isLoading" class="loading">Loading&#8230;</div>


<div class="columns is-centered is-gapless is-multiline" style="margin-bottom:1em;">

<div v-if="showHeader=='true'" class="column pl-4 is-9 is-size-4 has-text-weight-bold">
    {{student_nom}} <span class="is-size-6 pl-3">{{student_grp}} </span>
</div>
<div v-else class="column is-9">&nbsp;</div>
<div class="column is-2">        
 <a @click="printit()" class="button is-fullwidth is-pulled-right has-background-white"><span class="icon"><i class="fas fa-print"></i></span>&nbsp;&nbsp;Print</a>         
</div>

<div v-if="showHeader =='true'" class="column is-1">        
 <a @click="close_modal_check()" class="button has-background-danger has-text-white is-pulled-right"><span class="icon"><i class="fas fa-window-close"></i></span></a>         
</div>

<!-- <div @click="modal_close()" class="column is-1 has-text-centered is-size-7 isLink has-text-grey-light"><span class="icon is-small has-text-left"><i class="fas fa-window-close"></i></span></div> -->

<!-- <div class="column is-12">&nbsp;</div>
<div class="column is-12">&nbsp;</div>
<div class="column is-12">&nbsp;</div> -->


<div class="column is-3 is-size-7">
    <span class="isLabel">Due:</span>&nbsp;&nbsp; <span class=" is-size-4 has-text-weight-bold">{{format_money(pay_amt_due,'$')}}</span> </div>
<div class="column is-3 is-size-7">
    <span class="isLabel">Pai:</span> &nbsp;&nbsp;<span class=" is-size-4 has-text-weight-bold">{{format_money(pay_amt_recu,'$')}}</span></div>
<div class="column is-3 is-size-7">
    <span class="isLabel">Solde:</span>&nbsp;&nbsp; <span class=" is-size-4 has-text-weight-bold">{{format_money(pay_amt_solde,'$')}}</span></div>
<div class="column is-3"></div>


     

<!-- <div class="column is-1">        
    <a class="button is-fullwidth has-background-grey-lighter has-text-black" @click="pay_cancel()">ETATE</a>
</div>
<div class="column is-1">        
    <a class="button is-fullwidth has-background-grey-lighter has-text-black" @click="pay_cancel()">INVOICE</a>
</div> -->
</div><!-- END HEADER SUMMARY -->


<!-- DETAILS !! -->




<!-- <div class="column is-1">
<div class="columns is-gapless is-multiline">
    <div class="column is-12 isLabel">AMOUNT</div>
    <div class="column is-12"><div class="field is-fullwidth" style=""><div class="control"><input v-model="pay_amount" class="input is-dark has-text-weight-semibold" placeholder=""></div></div></div>
</div>
</div>
<div class="column is-2">
<div class="columns is-gapless is-multiline">
    <div class="column is-12 isLabel">DATE DUE</div>
    <div class="column is-12">
        <flat-pickr
            class="input is-dark has-text-weight-bold has-text-centered"
            :config="config_long"
            v-model="pay_dt_due"
            placeholder="" 
            name="dtDue">
        </flat-pickr>
    </div>
</div>
</div>
<div class="column is-1 has-text-right">
 <div class="columns is-gapless is-multiline">   
    <div class="column is-12 isLabel">RECU&nbsp;&nbsp;&nbsp;&nbsp;</div>
    <div class="column is-12">
    <div class="field" style="">
        <input v-model="pay_recu" id="switchRtlExample" type="checkbox" name="switchRtlExample" class="switch is-success" checked="checked">
        <label class="is-size-7 has-text-centered" for="switchRtlExample"></label>
    </div>
    </div>
</div>
</div>
<div class="column is-1">
 <div class="columns is-gapless is-multiline">   
    <div class="column is-12 isLabel">&nbsp;TYPE</div>
    <div class="column is-12">
        <div class="select is-fullwidth">
        <select v-model="pay_type">
            <option>A</option>
            <option>C</option>
            <option>D</option>
            <option>M</option>
        </select>
    </div>
    </div>
</div>
</div>
<div class="column is-2">
<div class="columns is-gapless is-multiline">
    <div class="column is-12 isLabel">DATE DUE</div>
    <div class="column is-12">
        <flat-pickr
            class="input is-dark has-text-weight-bold has-text-centered"
            :config="config_long"
            v-model="pay_dt_pay"
            placeholder="" 
            name="dtDue">
        </flat-pickr>
    </div>
</div>
</div>
<div class="column is-5">
<div class="columns is-gapless is-multiline" style="padding-left:10px;">
    <div class="column is-12 isLabel">NOTES</div>
    <div class="column is-12">
    <div class="field is-fullwidth"><div class="control"><input v-model="pay_note" class="input is-dark has-text-weight-semibold" placeholder=""></div></div>
    </div>
</div>
</div>



<div class="column is-1"> 
        <button @click="pay_cancel()" class="button is-size-7 is-fullwidth has-text-weight-bold has-background-grey-light	has-text-white" style="">
            <span class="icon has-text-left"><i class="fas fa-window-close"></i>&nbsp;FERMER</span>     
        </button>
</div>
<div class="column is-1"> 
        <button @click="show_pay_delete=!show_pay_delete" class="button is-size-7 is-fullwidth has-text-weight-bold has-background-danger has-text-white" style="">
            <span class="icon has-text-left"><i class="fas fa-trash"></i>&nbsp;DELETE</span>     
        </button>
</div>

<div v-if="show_pay_delete == true" class="column is-2"> 
        <button @click="pay_delete()" class="button is-size-7 is-fullwidth has-text-weight-bold has-background-danger has-text-white" style="">
            <span class="icon has-text-left"><i class="fas fa-trash"></i>&nbsp;OK</span>     
        </button>
</div>
<div v-if="show_pay_delete == true" class="column is-6">&nbsp;</div>
<div v-else class="column is-8">&nbsp;</div>

<div class="column is-2"> 
        <button @click="pay_save()" class="button is-size-7 is-fullwidth has-text-weight-bold has-background-success has-text-white" style="">
            <span class="icon has-text-left"><i class="fas fa-save"></i>&nbsp;ENREGISTRER</span>     
        </button>
</div> -->



<!-- END SHOW DETAILS !!!! -->
<div class="columns is-multiline is-centered is-vcentered" style="margin-bottom:4em;">
<div class="column is-4">

<div class="columns is-multiline is-gapless is-centered is-vcentered">
    <div class="column is-1"></div> 
<div class="column is-6 is-uppercase"><span class="has-text-grey"> Frais étudiants </span></div>
<!-- <div class="column is-1"></div> -->
<div class="column is-2"><button @click="fee_add_defaults_confirm()" title="Add Default Fees" class="button is-small is-fullwidth has-background-white has-text-link"><span class="icon is-small has-text-left"><i class="fas fa-file-invoice-dollar"></i></span></button></div>
 
<div class="column is-2"><button @click="fee_click(-1)" title="Add Fee" class="button is-small is-fullwidth has-background-white has-text-success"><span class="icon is-small has-text-left"><i class="fas fa-plus"></i></span></button></div>

<!-- SHOW FEEs  -->
<div v-if="+show_fees" class="column is-12" style="margin-bottom:2em;">
<div class="columns is-gapless is-multiline is-centered">

<div class="column is-2"></div>
<div class="column is-8"><div class="field is-fullwidth" style=""><div class="control"><input v-model="fee_desc" class="input has-text-weight-semibold" placeholder="Fee desc."></div></div></div>
<div @click="fee_close()" class="column mt-3 is-2 has-text-centered is-size-7 isLink has-text-grey-light"><span class="icon is-small has-text-left"><i class="fas fa-window-close"></i></span></div>

<div class="column is-2"></div>
<div class="column is-4"><div class="field is-fullwidth" style=""><div class="control"><input v-model="fee_cost" class="input has-text-weight-semibold" type="number" placeholder="Fee desc."></div></div></div>

<div class="column is-1">
<a class="button is-fullwidth has-background-danger-light has-text-danger" @click="delete_fee_confirm()"><span class="icon is-small"><i class="fas fa-trash"></i></span></a>
   </div>
   <div class="column is-3">
<a class="button is-fullwidth has-background-success-light has-text-success" @click="fee_save()"><span class="icon is-small"><i class="fas fa-save"></i></span></a>
   </div> 
<div class="column is-2"></div>
</div></div>
<!-- END SHOW FEEs  -->

<div class="column is-11">
<div style="" class="columns has-text-weight-bold has-text-grey is-gapless">

<div class="column is-9 borderIt has-text-weight-bold isLabel has-background-light">&nbsp;&nbsp;Description</div>
<div class="column is-3 borderIt has-text-weight-bold isLabel has-background-light has-text-centered">Amount</div>
</div></div>

<div class="column is-11">
<div class="columns is-gapless is-multiline is-centered is-vcentered colBorderThin" v-for="(data, index) in data_fees" :key="index" style="margin-bottom:0em;">

<div @click="fee_click(index)" class="column is-9 isLink colNotes" style="border-right:1px solid gray;">&nbsp;&nbsp;{{ data.studentFee_DESC }}</div>
<div @click="fee_click(index)" class="column is-3 isLink has-text-right"> {{ data.studentFee_AMT }}&nbsp;&nbsp;</div>
</div></div>
<!-- END FEEs DETAILS  -->

</div></div>
<!-- END FEE COLuMN  -->

<div class="column is-8">

<div v-if="show_pay_details == true" class="columns is-multiline" style="">
<div class="column is-4">
    <div class="columns is-gapless is-multiline">
        <div class="column is-4 isLabel">AMOUNT</div>
        <div class="column is-8"><div class="field is-fullwidth" style=""><div class="control"><input v-model="pay_amount" type="number" class="input is-dark has-text-weight-semibold" placeholder=""></div></div></div>
    
    <div class="column is-4 isLabel">DAT DU</div>
    <div class="column is-8">
        <flat-pickr
            class="input is-dark has-text-weight-bold has-text-centered"
            :config="config_long"
            v-model="pay_dt_due"
            placeholder="Dat Du" 
            name="dtDue">
        </flat-pickr>
    </div>
</div></div>



<div class="column is-6"> 

 <div class="columns is-gapless is-multiline">   
     <div class="column is-1 is-size-7">RECU</div>
    <div class="column is-3 has-text-centered">
    <div class="field" style="">
        <input @change="pay_recu_change()" v-model="pay_recu" id="switchRtlExample" type="checkbox" name="switchRtlExample" class="switch is-success" checked="checked">
        <label class="is-size-7 has-text-centered" for="switchRtlExample"></label>
    </div>
    </div>
    <div class="column is-3">
        <div class="select is-fullwidth">
        <select v-model="pay_type">
            <option>A</option>
            <option>C</option>
            <option>D</option>
            <option>M</option>
        </select>
    </div>
    </div>
    <div class="column is-5">
        <flat-pickr
            class="input is-dark has-text-weight-bold has-text-centered"
            :config="config_long"
            v-model="pay_dt_pay"
            placeholder="Dat Recu" 
            name="dtRec">
        </flat-pickr>
    </div>

    <div class="column is-11">
        <div class="field is-fullwidth"><div class="control"><input v-model="pay_note" class="input is-dark has-text-weight-semibold" placeholder="Notes"></div></div>
    </div>

    <div class="column is-1">
        <a class="button is-fullwidth has-background-danger-light has-text-danger" @click="pay_delete_confirm()"><span class="icon is-small"><i class="fas fa-trash"></i></span></a>
    </div>

</div>
</div>

<div class="column is-2"> 
 <div class="columns is-gapless is-multiline">  

    <div @click="pay_cancel()" class="column is-12 has-text-centered is-size-7 isLink has-text-grey-light"><span class="icon is-small has-text-left"><i class="fas fa-window-close"></i></span></div>

    <div class="column is-12 mt-4">
        <a class="button is-fullwidth has-background-success-light has-text-success" @click="pay_save()"><span class="icon is-small"><i class="fas fa-save"></i></span></a>
    </div> 

</div></div>
</div>




<div class="columns is-gapless is-multiline is-centered is-vcentered">
<div class="column is-10 is-uppercase"><span class="has-text-grey">&nbsp;&nbsp;&nbsp;&nbsp;Calendrier de paiement</span> </div>
<div class="column is-2"><button @click="pay_open()" class="button is-small is-fullwidth has-background-white has-text-success"><span class="icon is-small has-text-left"><i class="fas fa-plus"></i></span></button></div>
<div class="column is-1"></div>

<div class="column is-12">
 
<div style="margin-bottom:0em;" class="columns has-text-weight-bold has-text-light is-gapless has-background-light">
<div class="column is-2 borderIt isLabel">&nbsp;&nbsp;Amount</div>
<div class="column is-2 borderIt isLabel">&nbsp;&nbsp;Dat due</div>
<div class="column is-1 borderIt isLabel">&nbsp;Type</div>
<div class="column is-1 borderIt isLabel">&nbsp;Recu</div>
<div class="column is-2 borderIt isLabel">&nbsp;&nbsp;Dat recu</div>
<div class="column is-4 borderIt isLabel colNotes">&nbsp;&nbsp;Notes</div>
</div>

<div v-if="data_payments">
<!-- PAYMENTS !!!!--> 
  <div style="margin-bottom:0em;" @click="pay_click(index)" class="columns is-multiline isLink is-gapless" v-for="(pay, index) in data_payments" :key="index">
<div class="column is-2 borderIt has-text-right"> {{ format_money(pay.payment_Amount,'$') }}&nbsp;&nbsp;
</div>
<div  class="column is-2 borderIt has-text-right"> {{ pay.payment_DueDate | moment("add", "1 days","MMM-D-YY") }}&nbsp;&nbsp;</div>

<div  class="column is-1 has-text-centered has-background-light has-text-black columnNoWrap borderIt">{{ pay.payment_Type }}</div>
<div class="column is-1 has-text-centered has-background-light has-text-black columnNoWrap borderIt">
<div class="columns">
    <div class="column is-12" style="margin-top:.5em;margin-bottom:-1em;">
        <span v-if="pay.payment_Rec" class="has-badge-rounded has-badge-left has-badge-success has-badge-small" data-badge="">&nbsp;</span> 
        <span v-else class="has-badge-rounded has-badge-left has-badge-warning has-badge-small" data-badge="">&nbsp;</span> 
    </div>
</div>
</div>
<div v-if="pay.payment_Rec"  class="column is-2 borderIt has-text-centered"> &nbsp;&nbsp;{{ moment(pay.payment_RecDate).format('MMM-DD-Y') }}</div>
<div v-else  class="column is-2 borderIt has-text-centered"> &nbsp;&nbsp;</div>
<div  class="column is-4 borderIt">&nbsp;&nbsp; {{ pay.payment_COMMENTS }}</div>
  </div>
</div>
<!-- END PAYMENT LIST -->


</div><!-- END 6 COLUMN !!!!-->
</div> <!-- END MAIN COLUMN !!!!-->


</div></div>
<!-- END CONAINER COLUMN  -->


<!-- **** COMMENTS COLUMN **** -->
<div class="columns is-multiline is-gapless">
    <div class="column is-12">
        <textarea  @keyup="set_mod()" v-model="student_frais_comments" class="textarea is-size-5 has-text-weight-semibold" placeholder="Note...."></textarea>
    </div>
    <div v-if="student_frais_mod" class="column is-12"> 
        <a class="button is-fullwidth has-background-success has-text-light" @click="comments_save()"><span class="icon is-small"><i class="fas fa-save"></i></span></a>
    </div>



</div>





<div v-if="show_print">
<!-- <div id="printMe"> -->
    <PrintAccount @emit_pdf_done="emit_pdf_done" :studentID="this.studentID" :fees="this.data_fees" :payments="this.data_payments" :key="randomKey()"></PrintAccount>
</div>
<!-- </div> -->
<!-- END PRINT  -->
 

</div>
</template>


<script>
import axios from 'axios';
import moment from 'moment';

import PrintAccount  from '@/components/print/print_account_statement';

export default {
  components: { PrintAccount },
  props: [ 'studentID', 'showHeader'  ],
  
  data() {
      return {
            isLoading:false,

pay_amt_due:0,
pay_amt_recu:0,
pay_amt_solde:0,

            pay_id:0,
            pay_index:-1,
            pay_note:'',
            pay_amount:'',
            pay_type:'',

            pay_recu:false,
            pay_dt_due:'',
            pay_dt_pay:'',

            pay_user:'', // sessionStorage.getItem('user_name'),
show_pay_details:false,
show_pay_delete:false,
            data_payments:[],

           config_long: { // FLATPICKER
                altFormat: "M j, y",
                altInput: true
            },

show_print:false,
output: null,

data_fees:[],
data_fees_program:[],

// IF VIEWING IN PAI COMPONENT
student_nom:'',
student_grp:'',
student_frais_comments:'',
student_frais_mod:false,

something_changed:false, // USED FOR SENDING BACK TO REFRESH SCREEN

show_fees:false,
fee_id:0,
fee_desc:'',
fee_cost:0,



}},

mounted() {
    //this.payments_get()
    // this.fee_get()

this.isLoading = true
var query = "SELECT prog_ID, MyMEQ_STUDENT_FEES.* FROM  MyMEQ_STUDENT LEFT OUTER JOIN MyMEQ_STUDENT_FEES ON MyMEQ_STUDENT.student_ID = MyMEQ_STUDENT_FEES.student_ID WHERE MyMEQ_STUDENT.student_ID = " + this.studentID + " ORDER BY studentFee_DATE"
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query)) 
.then(res => { 
    this.data_fees = res.data

// GET PAYMENTS & PAI COMMENTS !
    var query = `SELECT MyMEQ_STUDENT.student_GRPCODE, MyMEQ_STUDENT.student_lNAME + ',  ' + MyMEQ_STUDENT.student_fNAME AS nom,student_frais_comments, MyMEQ_STUDENT_PAYMENT.* FROM MyMEQ_STUDENT LEFT OUTER JOIN MyMEQ_STUDENT_PAYMENT ON MyMEQ_STUDENT.student_ID = MyMEQ_STUDENT_PAYMENT.student_ID WHERE (MyMEQ_STUDENT.student_ID = '` + this.studentID + `')
     ORDER BY payment_DueDate`
    this.isLoading=true;
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
        this.student_nom = res.data[0].nom
        this.student_grp = res.data[0].student_GRPCODE
        this.student_frais_comments = res.data[0].student_frais_comments

        this.data_payments = res.data
        this.fee_get_totals()
        this.isLoading=false;

    }); });
},



methods: {


comments_save:function() {
// SAVE THE COMMENTS
    var sql = "UPDATE myMEQ_STUDENT SET student_frais_comments = '" + this.student_frais_comments.replace(/'/g,"''") + "' WHERE student_ID = " + this.studentID
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
    .then(res => { 
        this.$snotify.success('SAVED!!' , {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom"});
        this.student_frais_mod = false
    });
},

set_mod:function(){
    this.student_frais_mod = true
},


close_modal_check:function() {  
    if (this.student_frais_mod==true)  {
    this.$snotify.error('You have unsaved changes ?', { timeout: 5000, showProgressBar: true, closeOnClick: true, pauseOnHover: false,
    position: "centerCenter", buttons: [
            {text: 'LEAVE', action: (toast) =>  { this.$snotify.remove(toast.id) ; this.close_modal()}},
            {text: 'STAY', action: (toast) => { this.$snotify.remove(toast.id)  ; return false  }},
        ]  });
    } else {this.close_modal()}    
}, // END SHOW CONTACT


close_modal:function(){
    this.$emit('modal_close', this.something_changed)
},

// FEES ************************
fee_add_defaults_confirm:function() {
// CHECK IF HAS PROGRAM -- FOR DEFAULT PAYMENTS
    if (this.data_fees.length < 0) {alert('No Program!') ; return}
    if (isNaN(this.data_fees[0].prog_ID)) {alert('No Program!') ; return}


    this.$snotify.html(`<div class="snotifyToast__title"><b>Insert Default Fees?</b></div>
  <div class="snotifyToast__body">`+ '' +`</div> ` , {
    timeout: 20000, showProgressBar: true, closeOnClick: false, pauseOnHover: true,position:"centerCenter", type:'info',
        buttons: [
            {text: 'Ok', action: (toast) => this.fee_add_defaults_do(toast), bold: true},
            {text: 'Cancel', action: (toast) => {this.$snotify.remove(toast.id); }, bold: true},
        ]
    });
},
fee_add_defaults_do:function(toast) {
    this.$snotify.remove(toast.id);

// GET FEES
    var query = "SELECT * FROM MyMEQ_PROGRAM_FEES WHERE prog_ID = " + this.data_fees[0].prog_ID
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
        this.data_fees_program = res.data
        query = ''
        for(var i = 0; i < this.data_fees_program.length; i++ ){
            query += "INSERT INTO MyMEQ_STUDENT_FEES (student_ID,studentFee_DESC,studentFee_AMT) VALUES ("
            query += this.studentID + ",'" + this.data_fees_program[i].progFee_DESC.replace(/'/g,"''") + "'," + this.data_fees_program[i].progFee_AMT + ");"
        } // END FOR
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
        this.isLoading = false
        this.something_changed=true
        this.fee_get()
    });   });
},

fee_get:function() {
this.isLoading = true
var query = "SELECT prog_ID, MyMEQ_STUDENT_FEES.* FROM  MyMEQ_STUDENT LEFT OUTER JOIN MyMEQ_STUDENT_FEES ON MyMEQ_STUDENT.student_ID = MyMEQ_STUDENT_FEES.student_ID WHERE MyMEQ_STUDENT.student_ID = " + this.studentID + " ORDER BY studentFee_DATE"
console.log(query)
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query)) 
.then(res => { 
    this.data_fees = res.data
    this.isLoading = false

    this.fee_get_totals(true)

});


},

fee_close:function() {
    this.show_fees=false
},
fee_click:function(index) {
// OPEN
    if (index == -1) {this.fee_id = 0; this.fee_desc = ''; this.fee_cost = 0}
    else  {

if (!this.data_fees[index].studentFee_ID)
{return}

        this.fee_id = this.data_fees[index].studentFee_ID; 
        this.fee_desc = this.data_fees[index].studentFee_DESC; 
        this.fee_cost = this.data_fees[index].studentFee_AMT
    }
    this.show_fees=true    
},
fee_save:function() {
var query = ''
if (this.fee_id == 0) {
    query = "INSERT INTO MyMEQ_STUDENT_FEES (student_ID,studentFee_DATE,studentFee_DESC,studentFee_AMT) VALUES (" + this.studentID + ",'" + moment().format('YYYY-MM-DD') + "','" + this.fee_desc.replace(/'/g,"''") + "'," + this.fee_cost + ")"
} else {
    query = "UPDATE [MyMEQ_STUDENT_FEES] "
    query += " SET "
    query += " [studentFee_DATE] = '" + moment().format('YYYY-MM-DD')
    query += "',[studentFee_DESC] = '" + this.fee_desc.replace(/'/g,"''")
    query += "',[studentFee_AMT] = " + this.fee_cost
    query += " WHERE studentFee_ID = " + this.fee_id
}


console.log(query)
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => { 
    this.$snotify.success('FEE SAVED!!' , {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
    this.fee_id = 0; this.fee_desc = ''; this.fee_cost = 0
    this.something_changed=true
    this.fee_get()
});

},

delete_fee_confirm:function(index) {


    
    this.$snotify.html(`<div class="snotifyToast__title"><b>Delete Fee?</b></div>
  <div class="snotifyToast__body">`+ this.fee_desc +`</div> ` , {
    timeout: 20000, showProgressBar: true, closeOnClick: false, pauseOnHover: true,position:"centerCenter", type:'error',
        buttons: [
            {text: 'Ok', action: (toast) => this.delete_fee_do(toast,index), bold: true},
            {text: 'Cancel', action: (toast) => {this.$snotify.remove(toast.id); }, bold: true},
        ]
    });



},
delete_fee_do:function(toast,index) {
this.$snotify.remove(toast.id);

    var query = "DELETE FROM MyMEQ_STUDENT_FEES WHERE studentFee_ID = " + this.fee_id
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
        this.$snotify.success('FEE DELETED!!' , {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
        this.show_fees=false 
        this.something_changed=true
        this.fee_get()
    });
},



// END FEES ************************



emit_pdf_done:function() {
    this.show_print = false
},

 printit() {
// this.create_pdf()
     this.show_print = true


    // this.sleep(1000).then(() => {  this.show_print = false });
        // this.$htmlToPaper('printMe', null, () => {
           
        // }); 
// },
// sleep:function(ms) {
//   return new Promise(resolve => setTimeout(resolve, ms));
 },

payments_get() {
// GET PAYMENTS
    var query = `SELECT * FROM MyMEQ_STUDENT_PAYMENT WHERE (student_ID = '` + this.studentID + `')
     ORDER BY payment_DueDate`
    this.isLoading=true;
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
        this.data_payments = res.data
        this.fee_get_totals(true)
        this.isLoading=false;
    });
},



fee_get_totals:function(update){
// GET TOTAL AMOUNT/PAY/SOLDE
this.pay_amt_due=0
this.pay_amt_recu=0
this.pay_amt_solde=0

    var self = this;
    this.data_payments.forEach(function(item){ 
        // self.pay_amt_due += Number(item.payment_Amount)
        if (item.payment_Rec == true) {self.pay_amt_recu += Number(item.payment_Amount)}
    });
    this.data_fees.forEach(function(item){ 
        self.pay_amt_due += Number(item.studentFee_AMT)
    });

    this.pay_amt_solde = Number(this.pay_amt_due) - Number(this.pay_amt_recu)


// UPDATE HERE !!
if (update) {
    var sql = "UPDATE myMEQ_STUDENT SET student_frais_owe = " + Number(this.pay_amt_due)
    sql += ", student_frais_pay = " + Number(this.pay_amt_recu)
    sql += ", student_frais_solde = " + Number(this.pay_amt_solde)
    sql += " WHERE student_ID = " + this.studentID
     axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
    .then(res => {    
        this.$emit('emit_fee_change', this.pay_amt_solde)
    });

}


},


pay_click:function(index) {
        this.pay_index = index


if (!this.data_payments[index].payment_ID)
{return}


        this.pay_id = this.data_payments[index].payment_ID
        this.pay_type = this.data_payments[index].payment_Type
        this.pay_note= this.data_payments[index].payment_COMMENTS
        this.pay_amount= this.data_payments[index].payment_Amount
        this.pay_recu= this.data_payments[index].payment_Rec
        this.pay_dt_due= this.data_payments[index].payment_DueDate
        this.pay_dt_pay= this.data_payments[index].payment_RecDate
        this.show_pay_details= true
},
pay_cancel:function() {
// JUST CLOSE 
        this.pay_index = -1
        this.pay_id = 0
        this.pay_note = ''
        this.pay_type = ''
        this.pay_amount = ''
        this.pay_recu= ''
        this.pay_dt_due= ''
        this.pay_dt_pay= ''
        this.show_pay_details=false
  //this.$emit('cancel_emit')


},
pay_open:function() {
    this.pay_clear()
    this.show_pay_details= true
},
pay_clear:function() {
// JUST CLOSE 
    this.pay_index = -1
    this.pay_id = 0
    this.pay_note = ''
    this.pay_type = ''
    this.pay_amount = ''
    this.pay_recu= ''
    this.pay_dt_due= ''
    this.pay_dt_pay= ''

},


pay_delete_confirm:function() {
    this.$snotify.html(`<div class="snotifyToast__title"><b>Delete Payment?</b></div>
  <div class="snotifyToast__body">`+ '$'+this.pay_amount +`</div> ` , {
    timeout: 20000, showProgressBar: true, closeOnClick: false, pauseOnHover: true,position:"centerCenter", type:'info',
        buttons: [
            {text: 'Ok', action: (toast) => this.pay_delete_do(toast), bold: true},
            {text: 'Cancel', action: (toast) => {this.$snotify.remove(toast.id); }, bold: true},
        ]
    });

},

pay_delete_do:function(toast) {
this.$snotify.remove(toast.id);
      // CHECK IF NOT SAVED
      if (this.pay_id == 0) {this.pay_clear(); this.show_pay_delete = false; return}


    var query = "DELETE FROM MyMEQ_STUDENT_PAYMENT WHERE payment_ID = " + this.pay_id
    this.isLoading=true;
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
            // this.data_payments.splice(this.pay_index, 1);
            this.pay_clear()
            this.payments_get(true)
            // this.fee_get_totals()
            this.show_pay_delete = false
            this.show_pay_details = false 
            this.isLoading=false;
            this.something_changed=true
    });

},


pay_save:function() {

if (+this.pay_amount < 0 ) {alert ('Enter Amount'); return}



    if (this.pay_id == 0 ) { 
        var query = "INSERT INTO MyMEQ_STUDENT_PAYMENT (student_ID,payment_Rec) VALUES (" + this.studentID + ",0);SELECT MAX(payment_ID) AS newID FROM MyMEQ_STUDENT_PAYMENT"
        axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
        .then(res => { 
            this.pay_id = res.data[0].newID
            this.pay_update()
        })
    } else {
        this.pay_update()
    } // END IF
},

pay_recu_change:function() {
    if (this.pay_recu) {
        this.pay_dt_pay = moment().format('YYYY-MM-DD')
        this.pay_type = 'C'
    } else {
        this.pay_dt_pay = ''
        this.pay_type = ''
    }
},

pay_update:function() {

if (this.pay_dt_due == '') {this.pay_dt_due="Null"} else {this.pay_dt_due= "'" + moment(this.pay_dt_due).format('YYYY-MM-DD') + "'"}
if (this.pay_dt_pay == '') {this.pay_dt_pay="Null"} else {this.pay_dt_pay= "'" + moment(this.pay_dt_pay).format('YYYY-MM-DD') + "'"}
if (this.pay_recu == '') {this.pay_recu = false}


var query = "UPDATE myMEQ_STUDENT_PAYMENT SET " 
query += " payment_AMOUNT = " + this.pay_amount 
query += ", payment_DueDate = " + this.pay_dt_due 
query += ", payment_Type = '" + this.pay_type + "'"
query += ", payment_Rec = " + +this.pay_recu 
query += ", payment_RecDate = " + this.pay_dt_pay
query += ", payment_COMMENTS = '" +  this.pay_note.replace(/'/g, "''")  + "' "
query += " WHERE payment_ID = " + this.pay_id
console.log(query)
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => { 
    console.log(res)
    this.something_changed=true
    this.payments_get(true)
    this.pay_clear() });



},


pay_save_XXX:function() {

if (this.pay_type == '') {return}
if (this.pay_amount == '') {return}
if(isNaN(this.pay_amount)){return}


    if (this.pay_id == 0 ) {          
          this.pay_id = this.randomKey()

//axios.post(this.$url+'/pay_insert?id='+ this.inID +'&payid='+this.pay_id +'&dt='+this.get_date()+'&note='+escape(this.pay_note)+'&user='+this.pay_user+'&type='+escape(this.pay_type)+'&amt='+escape(this.pay_amount))
//.then(response =>{ })
//.catch(e => { console.log(e)})          
  
            var obj = {
                payment_ID: this.pay_id,  
                payment_DueDate: this.pay_dt_due,
                payment_Amount: this.pay_amount,
                payment_Rec: this.pay_recu,
                payment_RecDate: this.pay_dt_pay,
                payment_Type: this.pay_type,
                payment_COMMENTS: this.pay_note
            };
            this.data_payments.unshift(obj);
    } else {
// UPDATE
        //axios.post(this.$url+'/pay_update?id='+ this.inID +'&payid='+this.pay_id +'&dt='+this.get_date()+'&note='+escape(this.pay_note)+'&user='+this.pay_user+'&type='+escape(this.pay_type)+'&amt='+escape(this.pay_amount))
        //.then(response =>{  })
        //.catch(e => { console.log(e)})

            this.data_payments[this.pay_index].payment_ID = this.pay_id
            this.data_payments[this.pay_index].payment_Type = this.pay_type
            this.data_payments[this.pay_index].payment_COMMENTS=this.pay_note
            this.data_payments[this.pay_index].payment_Rec=this.pay_recu
            this.data_payments[this.pay_index].payment_Amount=this.pay_amount
            this.data_payments[this.pay_index].payment_DueDate=this.pay_dt_due
            this.data_payments[this.pay_index].payment_RecDate=this.pay_dt_pay


    } // END INSERT/UPDATE
    this.pay_clear()

    this.fee_get_totals()
    //this.$emit('mod_emit_pay',paid);
},



get_date: function() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();
    if (dd < 10) { dd = '0' + dd;}
    if (mm < 10) {mm = '0' + mm;}
    return  yyyy + '-' + mm + '-' + dd;
},

format_money:function (n, currency) {
    if (isNaN(n)) {return}
    try {return currency + parseFloat(n).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");}
    catch(err) {return '-'}
},
// GENERATE A NEW ID! 
randomKey:function() {
return 'xxxxxxxx-xxxx-4xxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
});},



} // END METHODS

}
</script>

<style scoped>

a {
    color:inherit;
}
.isLabelHeader{
    font-size:80%;
    font-weight: 900;
    color:#732B34;  
}
.columnNoWrap {
    white-space: nowrap;
    overflow: hidden;
}

.borderIt {
  border: 1px solid  darkgray;
  padding:2px;
}
.margeBottomLess{
  margin-bottom: -14px;
}
</style>
